import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import Container from "./Container";
import MultiCrousel from "./MultiCrousel";
import SectionCount from "./SectionCount";
import {
  TrendingUp,
  Building2,
  Globe,
  Handshake,
} from "lucide-react";

function TopCities() {
  const sectionCounts = [
    {
      num: 3500,
      text: "Properties Sold",
      Icon: <TrendingUp strokeWidth={2} />,
    },
    {
      num: 230,
      text: "Projects Handled",
      Icon: <Building2 strokeWidth={2} />,
    },
    {
      num: 400,
      text: "NRI Clients Served",
      Icon: <Globe strokeWidth={2} />,
    },
    {
      num: 40,
      text: "Builders, Marketing Partners",
      Icon: <Handshake strokeWidth={2} />,
    },
  ];

  const Featured = [
    {
      key: 1,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "9000000",
      imgUrl: "/h1.jpg",
    },
    {
      key: 2,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "1000000",
      imgUrl: "/h2.jpg",
    },
    {
      key: 3,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "6000000",
      imgUrl: "/h3.jpg",
    },
  ];

  return (
    <motion.section
      className="relative overflow-hidden border-t border-slate-100 bg-gradient-to-b from-white via-slate-50/40 to-white py-12 md:py-16 lg:py-20 padingm"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      <div
        className="pointer-events-none absolute left-0 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-[#FECE51]/10 blur-3xl"
        aria-hidden
      />
      <Container className="relative max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-stretch lg:gap-12 xl:gap-16">
          <div className="flex-1 space-y-4 lg:max-w-xl lg:pt-1">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200/90 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#727272] shadow-sm">
              <MapPin className="h-3.5 w-3.5 text-[#0F172A]" aria-hidden />
              Nationwide reach
            </div>
            <h2 className="text-[#0F172A]">Properties In Top Cities</h2>
            <p className="max-w-lg text-[14px] leading-relaxed text-[#727272] md:text-[15px]">
              Find the home of your dreams at the finest cities of India with the
              budget you prefer. Explore apartments, villas, plots and farmlands
              across the nation.
            </p>
            <hr className="h-1 w-20 rounded-full bg-[#FECE51]" />
            <SectionCount numbers={sectionCounts} />
          </div>

          <div className="min-w-0 flex-1 lg:w-[52%] lg:max-w-none">
            <div className="h-full rounded-2xl border border-slate-200/90 bg-white p-3 shadow-[0_12px_40px_rgba(15,23,42,0.06)] ring-1 ring-black/[0.02] md:p-5">
              <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#727272] md:text-[11px]">
                Spotlight properties
              </p>
              <MultiCrousel
                data={Featured}
                autoplay={true}
                carouselVariant="listings"
              />
            </div>
          </div>
        </div>
      </Container>
    </motion.section>
  );
}

export default TopCities;
